import { Platform, StyleSheet } from "react-native";
import { View, Text, Button } from "../../../components/Themed";
import Colors from "../../../constants/Colors";
import Tag from "../../../components/Tag";

export const OpenHouseInformation = (props: any) => (
  <View
    lightColor={Colors.background}
    darkColor={Colors.nuetral_grey_600}
    style={[
      styles.openHouseInformation,
      {
        paddingHorizontal: props.isTablet ? 32 : 16,
      },
      Platform.OS === "web"
        ? {
            width: "75%",
            alignSelf: "center",
          }
        : null,
    ]}
  >
    {props.children}
  </View>
);

export const OpenHouseInformationTopContainer = (props: any) => (
  <View style={styles.openHouseInformationTopContainer}>{props.children}</View>
);

export const OpenHouseInformationTopSection = (props: any) => (
  <View style={styles.openHouseInformationTopSection}>{props.children}</View>
);

export const OpenHouseInformationLabel = ({
  label,
  value,
  isTablet,
}: {
  label: string;
  value: string;
  isTablet: boolean;
}) => (
  <View style={styles.labelContainer}>
    <Text
      weight="SemiBold"
      size={isTablet ? 16 : 14}
      lightColor={Colors.nuetral_grey_700}
    >
      {label}
    </Text>
    <Text size={isTablet ? 16 : 14} lightColor={Colors.nuetral_grey_700}>
      {value}
    </Text>
  </View>
);

export const OpenHouseInformationButtonContainer = (props: any) => (
  <View
    style={[
      styles.openHouseInformationButtonContainer,
      {
        paddingTop: props.isTablet ? 0 : 12,
      },
    ]}
  >
    {props.children}
  </View>
);

export const OpenHouseTags = ({
  tags,
  isTablet,
}: {
  tags: any;
  isTablet: boolean;
}) =>
  tags && (
    <View style={styles.labelContainer}>
      <Text
        weight="SemiBold"
        size={isTablet ? 16 : 14}
        lightColor={Colors.nuetral_grey_700}
      >
        Tags:
      </Text>

      {tags?.map((tag, index) => {
        return <Tag key={index} text={tag.tag}></Tag>;
      })}
    </View>
  );

export const OpenHouseNotes = ({
  notes,
  isTablet,
}: {
  notes: string;
  isTablet: boolean;
}) => (
  <View style={styles.labelContainer}>
    <Text
      weight="SemiBold"
      size={isTablet ? 16 : 14}
      lightColor={Colors.nuetral_grey_700}
    >
      Notes:
    </Text>
    <Text
      style={{ flexShrink: 1 }}
      size={isTablet ? 16 : 14}
      lightColor={Colors.nuetral_grey_700}
    >
      {notes}
    </Text>
  </View>
);

const styles = StyleSheet.create({
  openHouseInformation: {
    paddingVertical: 24,
    gap: 6,
  },
  openHouseInformationTopContainer: {
    flexDirection: "row",
    backgroundColor: "transparent",
  },
  openHouseInformationTopSection: {
    flexDirection: "column",
    flex: 1,
    gap: 6,
  },
  labelContainer: {
    flexDirection: "row",
    gap: 2,
    flexWrap: "wrap",
  },
  openHouseInformationButtonContainer: {
    flexDirection: "row",
    gap: 6,
    justifyContent: "space-between",
  },
});
